import gsap from 'gsap'
import { shuffle, moveOneLetter, marquee } from '../utils/string'
import { shuffleContainerTexts, shuffleElementTexts } from '../utils/html'

const DURATION = 0.25;

export default {
    name: 'work-next',
    leave(data) {
        const overline = data.current.container.querySelector('.c-work-next_overline')

        const tl = gsap.timeline()

        const shufflePerSecond = 16;
        const shuffleDelay = DURATION/shufflePerSecond

        for(let i = 0; i < shufflePerSecond; i++) {
            tl.call(() => { shuffleContainerTexts(overline, moveOneLetter) }, {}, shuffleDelay*i)
        }

        // const fadeOut = gsap.to(overline, {
        //     opacity: 0,
        //     duration: DURATION
        // })

        return Promise.all([tl])

        // return new Promise(resolve => resolve());
    },
    enter(data) {
        document.documentElement.scrollTop = 0

        const fadeInEl = data.next.container.querySelector('.c-work-single-hero_grid.-top');

        let inviewItems = []
        let targets = fadeInEl.querySelectorAll('*')
        for(let target of targets) {
            if((!target.children.length || target.dataset.allowShuffle != undefined) && target.innerText) {
                inviewItems.push(target)
                target.setAttribute('aria-label', target.innerText)
            }
        }

        const tl = gsap.timeline({
            onComplete: () => {
                for(let item of inviewItems) {
                    item.innerText = item.getAttribute('aria-label')
                    item.removeAttribute('aria-label')
                }
            }
        })

        const shufflePerSecond = 16;
        const shuffleDelay = DURATION/shufflePerSecond

        for(let i = 0; i < shufflePerSecond; i++) {
            for(let item of inviewItems) {
                tl.call(() => { shuffleElementTexts(item, moveOneLetter) }, {}, shuffleDelay*i)
            }
        }

        return tl
    },
    from: {
        custom({trigger}) {
            return trigger && trigger.dataset && trigger.dataset.loadTransition == 'work-next';
        }
    }
}
